"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var types_1 = require("../types");
var constants_1 = require("../constants");
exports.THEME_CONTEXT = React.createContext(constants_1.themes[types_1.ThemesCollection.dark]);
